import { Box, Button, Checkbox, Dialog, FormControl, FormControlLabel, Grid, InputLabel, Typography } from "@mui/material";
import { useEffect, useMemo, useRef, useState } from "react";
import PdfPreview from "../../../../components/PdfPreview"; 
import { createSupplyPDF } from "../../../../features/pdf/supplyPdf/SupplyPDF";
import { postSearchSupply, postSearchSupplyDivisions, postSearchSupplyForPrint } from "../../../../http/api/SupplyAPI";
import SupplyDivisionSelect from "./SupplyDivisionSelect";
import { CheckBox } from "@mui/icons-material";

const PrintPreviewDialog = ({isOpen, onClose, deliveryDate, supplyDivisionId, targetSupplier}) => {

  const supplyDetailsRef = useRef([]);
  
  const [supplyDivisions, setSupplyDivisions] = useState([]);
  const [supplyDivisionValue, setSupplyDivisionValue] = useState(supplyDivisionId);
  const [printSetting, setPrintSetting] = useState({
    needsOutputNo: false,
    sendingAgain: false
  });

  const [pdfUrl, setPdfUrl] = useState(null);

  useEffect(() => {
    (async () => {
      if (isOpen) {
        await initializeDialog(deliveryDate, supplyDivisionId, targetSupplier);
      } else if (pdfUrl) {
        destroyDialog(pdfUrl);
      }
    })();
  }, [isOpen]);

  const initializeDialog = async (deliveryDate, supplyDivisionId, targetSupplier) => {
    try {

      const supplyDivisionsRes = await postSearchSupplyDivisions({
        commodityOwnerCd: targetSupplier.commodityOwnerCd
      });
      
      setSupplyDivisions(supplyDivisionsRes.supplyDivisions);
      setSupplyDivisionValue(supplyDivisionId);

      const supplyDetailsRes = await postSearchSupplyForPrint({
        deliveryDate,
        supplyDivisionId,
        commodityOwnerCd: targetSupplier.commodityOwnerCd
      });

      const supplyDetails = supplyDetailsRes.supplyInfo.supplyDetails;
      const printSetting = {
        ...supplyDetailsRes.supplyPrintSetting,
        sendingAgain: false
      };

      setPrintSetting(printSetting)
      supplyDetailsRef.current = supplyDetails;

      updatePreview(supplyDetails, deliveryDate, supplyDivisionId, targetSupplier, printSetting);
    } catch (e) {
      console.log(e);
      alert("発注書PDFの作成に失敗しました。")
    }
    
  }

  const onChangeDivision = async (divisionId) => {
    setSupplyDivisionValue(divisionId);

    const supplyDetailsRes = await postSearchSupplyForPrint({
      deliveryDate,
      supplyDivisionId: divisionId,
      commodityOwnerCd: targetSupplier.commodityOwnerCd
    });

    const supplyDetails = supplyDetailsRes.supplyInfo.supplyDetails;
    supplyDetailsRef.current = supplyDetails;

    const printSetting = {
      ...supplyDetailsRes.supplyPrintSetting,
      sendingAgain: false
    }

    setPrintSetting(printSetting);
    updatePreview(supplyDetails, deliveryDate, divisionId, targetSupplier, printSetting);
  } 

  const onChangePrintSetting = (newPrintSetting) => {
    setPrintSetting(newPrintSetting);
    updatePreview(supplyDetailsRef.current, deliveryDate, supplyDivisionValue, targetSupplier, newPrintSetting);
  }

  const destroyDialog = (url) => {
    URL.revokeObjectURL(url);
    setPdfUrl(null);   
  }

  const updatePreview = async (supplyDetails, deliveryDate, supplyDivisionId, supplier, printSetting) => {
    try {
      const pdf = await createSupplyPDF(supplyDetails, deliveryDate, supplyDivisionId, supplier, printSetting);
      const file = new Blob([pdf], {type: "application/pdf"});
      setPdfUrl(URL.createObjectURL(file));
    } catch(e) {
      throw(e);
    }
  }

    // FAX送付は中止
  // const setTargetSuppliers = (supplyDetails, suppliers) => {
  //   const suppliesCounts = countSuppliesGroupingBySuppliers(supplyDetails, suppliers);

  //   setSuppliers(
  //     suppliers.map((supplier) => ({
  //       ...supplier,
  //       disabled: suppliesCounts[supplier.commodityOwnerCd] === 0,
  //       isSelected: suppliesCounts[supplier.commodityOwnerCd] > 0,
  //     }))
  //   )
  // }

  // const openDestinaionDrawer = () => {
  //   setOpenDrawer(true);
  // }

  // const closeDestinaionDrawer = () => {
  //   setOpenDrawer(false);
  // }


  // const handleChangeSelectedSupplierAt = (supplierIndex) => (isSelected) => {

  //   const newSuppliers = suppliers.map((supplier, index) => (
  //     index === supplierIndex
  //       ? {...supplier, isSelected}
  //       : {...supplier}
  //   ));

  //   setSuppliers(newSuppliers);

  //   updatePreview(
  //     supplyDetailsRef.current,
  //     deliveryDate,
  //     newSuppliers.filter((supplier)=> supplier.isSelected)
  //   );
  // };

  // const sendSupplyFax = async (supplyProducts, deliveryDate, suppliers) => {

  //   const commodityOwnerRes = await getCommodityOwnerInfo({});

  //   const supplierFaxList
  //     = commodityOwnerRes.listCommodityOwnerInfo
  //       .filter((commodityOwner) => 
  //         suppliers.some((supplier)=> 
  //           commodityOwner.commodityOwnerCd === supplier.commodityOwnerCd
  //         )
  //       )
  //       .reduce((prevList, commodityOwner) => ({
  //         ...prevList,
  //         [commodityOwner.commodityOwnerCd]: commodityOwner.fax
  //       }), {});

  //   try {
  //     const faxProps = await Promise.all(
  //       suppliers.map(async (supplier) => {
  //         const pdf = await createSupplyPDF(supplyProducts, deliveryDate, [supplier]);
  //         return ({
  //           faxFileUrl : URL.createObjectURL(new Blob([pdf], {type: "application/pdf"})),
  //           faxNumbers : [supplierFaxList[supplier.commodityOwnerCd]]
  //         })
  //       })
  //     );
  
  //     await sendFax(faxProps);
  //     alert("FAXを送付しました。");

  //   } catch (e) {
  //     alert("FAX送信に失敗しました。")
  //   }
    
  // }

  // const handleClickSendFax = async () => {
  //   await sendSupplyFax(supplyDetailsRef.current, deliveryDate, suppliers.filter((supplier)=> supplier.isSelected));
  //   onClose({status: "SENT_FAX"})();
  // }

  const handleClickReturn = () => {
    onClose(null)();
  }

  // const disabledSendFaxButton = useMemo(() => (
  //   !suppliers.some((supplier)=> supplier.isSelected)
  // ), [suppliers]);

  return (
    <Dialog fullScreen open={isOpen} onClose={onClose(null)}>
      <Box padding={2}>
        <Grid container alignItems="center" spacing={2}>
          <Grid item xs="auto">
            <Typography>帳票PDFプレビュー</Typography>
          </Grid>
          <Grid item xs>
            発注区分: 
            <SupplyDivisionSelect
              supplyDivisions={supplyDivisions}
              supplyDivisionValue={supplyDivisionValue}
              changeSupplyDivision={onChangeDivision}
            />
          </Grid>
          {/* <Grid item xs="auto">
            <Button
              variant="contained"
              onClick={openDestinaionDrawer}
            >
              送信先選択
            </Button>
          </Grid> */}
        </Grid>

        <Box height="calc(100vh - 130px)" marginY={1}>
          <PdfPreview pdfUrl={pdfUrl} />
        </Box>

        <Box MarginTop={1}>
          <Grid container spacing={1}>
            <Grid item xs="auto">
              <FormControlLabel
                control={
                  <Checkbox
                    checked={printSetting.needsOutputNo}
                    onChange={
                      (e) => onChangePrintSetting({...printSetting, needsOutputNo: e.target.checked})
                    }
                  />
                }
                label="Noを出力する"
              />
            </Grid>
            <Grid item xs>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={printSetting.sendingAgain}
                    onChange={
                      (e) => onChangePrintSetting({...printSetting, sendingAgain: e.target.checked})
                    }
                  />
                }
                label="再送"
              />
            </Grid>
            {/* FAX送付は中止 */}
            {/* <Grid item xs="auto">
              <Button
                variant="contained"
                onClick={handleClickSendFax}
                disabled={disabledSendFaxButton}
              >
                FAX送付
              </Button>
            </Grid> */}
            <Grid item xs="auto">
              <Button
                variant="outlined"
                onClick={handleClickReturn}
              >
                戻る
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Box>
      {/* <SelectDestinationDrawer     
        open={isOpenDrawer}
        onClose={closeDestinaionDrawer}
        items={suppliers}
        onChangeSelectAt={handleChangeSelectedSupplierAt}
      /> */}
    </Dialog>
  );
};

export default PrintPreviewDialog;